export const DEFAULT_TRANSITION_TIME = 250;

export const FORM_ROW_CLASS = 'form-row';
export const FORM_ROW_ERROR_CLASS = 'form-row--error';
export const FORM_ERROR_CLASS = 'form-row__error';
export const FORM_ERROR_ONE_CLASS = 'form-row--one-error';
export const FORM_SENDED_CLASS = 'form-sended';
export const WEIGHT_SYMBOL = 'g';
export const THICKNESS_SYMBOL = 'mm';
export const PRODUCT_PAGE_CLASS = 'p-detail-product';
export const RADIO_INPUT_CLASS = 'js-product-radio-input';
export const CHECKBOX_INPUT_CLASS = 'js-product-checkbox-input';
export const EMBLA_JS_FILE = 'embla';
export const EMBLA_LOADED_VAR = 'emblaLoaded';
export const U_DN_CLASS = 'u-dn';
export const BEFORE_SUBMIT_EVENT = 'beforeSubmit';
export const EVENT_URL = 'sendFormToUrl';

export function setNotificationActive(value) {
  window.isNotificationActive = value;
}
